export const ALL_TERMINALS_VALUE = "ALL";

export function flattenReportTransactions(data) {
  if (!data?.terminals?.length) return [];
  return data.terminals.flatMap((terminal) =>
    (terminal?.transactions || []).map((transaction) => ({
      ...transaction,
      terminalID: terminal.terminalID,
    })),
  );
}

export function getTransactionSearchDedupKey(transaction, terminalID) {
  const transactionId =
    transaction?.acquirer?.transactionID ||
    transaction?.blokko?.transactionID ||
    "";
  return `${terminalID}:${transactionId}:${transaction?.createdAt || ""}:${transaction?.updatedAt || ""}`;
}

export function mergeTransactionSearchResponses(responses) {
  if (!responses?.length) return null;
  if (responses.length === 1) return responses[0];

  const merged = JSON.parse(JSON.stringify(responses[0]));
  const seen = new Set();

  for (const terminal of merged.terminals || []) {
    for (const transaction of terminal.transactions || []) {
      seen.add(getTransactionSearchDedupKey(transaction, terminal.terminalID));
    }
  }

  for (let i = 1; i < responses.length; i += 1) {
    const response = responses[i];
    for (const terminal of response.terminals || []) {
      let targetTerminal = (merged.terminals || []).find(
        (item) => item.terminalID === terminal.terminalID,
      );

      if (!targetTerminal) {
        targetTerminal = {
          ...terminal,
          transactions: [...(terminal.transactions || [])],
        };
        merged.terminals = merged.terminals || [];
        merged.terminals.push(targetTerminal);
        for (const transaction of targetTerminal.transactions) {
          seen.add(
            getTransactionSearchDedupKey(transaction, targetTerminal.terminalID),
          );
        }
        continue;
      }

      targetTerminal.transactions = targetTerminal.transactions || [];
      for (const transaction of terminal.transactions || []) {
        const key = getTransactionSearchDedupKey(
          transaction,
          terminal.terminalID,
        );
        if (seen.has(key)) continue;
        seen.add(key);
        targetTerminal.transactions.push(transaction);
      }
    }
  }

  return merged;
}
